import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  readonly baseUrl = environment.financialPlanner.url;

  constructor(private httpClient: HttpClient) {}

  sendAgentLifePlan(lifePlanId: string, lifePlanTitle: string, recipientEmail: string) {
    return this.httpClient.post(`${this.baseUrl}/life-plans/${lifePlanId}/send`, {
      title: lifePlanTitle,
      email: recipientEmail
    });
  }
}
